import { OrderFeedbackReplyAddressState } from './types'

// Mirrors nexus PR thanx/nexus#1976's own column defaults
// (order_feedback_reply_mode defaults to 'user', order_feedback_reply_address
// is nullable and starts blank), and both fields seed edited/persisted equally
// so the pane opens CLEAN before the initialize hook resolves the real
// merchant, rather than flashing a dirty Publish button on first paint.
export const initialOrderFeedbackReplyAddressState: OrderFeedbackReplyAddressState =
  {
    replyMode: 'user',
    replyAddress: '',
    persistedReplyMode: 'user',
    persistedReplyAddress: '',
    isFormSubmitting: false,
  }
